import { groupByFunction } from './utils/rxjs/groupByFunction';
import alertAudio from '../../audio/alertAudio.wav';
import orderFill from '../../audio/orderPing.mp3';
import setupFailed from '../../audio/filterFail.mp3';
import tradePlanDeactivated from '../../audio/deactivatedFail.mp3';

export class AudioStore {
  root;
  applicationType = null;
  pathType = null;

  constructor(root) {
    this.root = root;
    this.pathType = root.type;
    this.initializeStream();
  }

  initializeStream() {
    groupByFunction(
      'messageType',
      'applicationType',
      this.root.websocketSubject
    ).subscribe((msg) => this.handleApplicationType(msg));

    groupByFunction(
      'messageType',
      'playSoundAlert',
      this.root.websocketSubject
    ).subscribe(this.handleAudioMessage);
  }
  handleApplicationType = (msg) => {
    this.applicationType = msg.name;
  };

  handleAudioMessage = (msg) => {
    const type = msg.soundType ?? null;
    if (type) {
      switch (type) {
        case 'orderFill':
          const audio = new Audio(orderFill);
          audio.play();
          break;
        case 'setupFailed':
          const audio2 = new Audio(setupFailed);
          audio2.play();
          break;
        case 'tradePlanDeactivated':
          const audio3 = new Audio(tradePlanDeactivated);
          audio3.play();
          break;
        case 'alertTriggered':
          const audio4 = new Audio(alertAudio);
          audio4.play(); 
          break;
        default:
          break;
      }
    }
  };
}
